function DeviceAssignmentCardView() {
    "use strict";

    this.Id = -1;
    this.ProductId = -1;
    this.Title = '';
    this.Description = '';
    this.OrganizationId = -1;
    this.IsAssignable = false;
    this.IsMultiAssignable = false;
    this.EnrolleeId = -1;
    this.IsBluPlus = false;
    this.Zone = '';
    this.ZoneId = 0;
}
if (typeof exports !== 'undefined') {
    module.exports = DeviceAssignmentCardView;
}